"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.WithGlobalNavContext = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var WithGlobalNavContext = /*#__PURE__*/(0, _react.createContext)({});
exports.WithGlobalNavContext = WithGlobalNavContext;

var WithGlobalNavProvider = function WithGlobalNavProvider(_ref) {
  var isLeftSidebarCollapsed = _ref.isLeftSidebarCollapsed,
      children = _ref.children;
  return (0, _jsxRuntime.jsx)(WithGlobalNavContext.Provider, {
    value: {
      isLeftSidebarCollapsed: isLeftSidebarCollapsed
    },
    children: children
  });
};

WithGlobalNavProvider.propTypes = {
  isLeftSidebarCollapsed: _propTypes.bool,
  children: _propTypes.node
};
WithGlobalNavProvider.defaultProps = {
  isLeftSidebarCollapsed: false,
  children: undefined
};
var _default = WithGlobalNavProvider;
exports["default"] = _default;
//# sourceMappingURL=WithGlobalNav.provider.js.map